import { type AdminRoute } from '../routing/AdminRoute';
import { NamespacesByRoute } from '../routing/NamespacesByRoute';
import { Ns } from './types';

export const I18N_NAMESPACES = Object.values(Ns);

export const defaultNamespaces = [Ns.Actions, Ns.Common, Ns.Components, Ns.Datetime, Ns.Url, Ns.RichEditor];

export const routeNamespaces: Record<AdminRoute, string[]> = NamespacesByRoute;

export const namespaces = { defaultNamespaces, routeNamespaces };
